import { EnvConfiguration } from './models';

const envLocal: EnvConfiguration = {
  AdminApiBaseUrl: 'http://localhost:5000/v1/admin',
  CoreApiBaseUrl: 'http://localhost:5000/v1',
  LeagueApiBaseUrl: 'http://localhost:5000/v1/league',
};
export default envLocal;
